module.exports = __webpack_public_path__ + "static/media/no-orders.54a47f8f.png";